/**
 * @see https://lemoine-benoit.medium.com/refinement-types-in-typescript-or-how-to-check-that-a-number-must-be-positive-at-compile-time-342c1e6e90e
 */
declare class NaturalNumberTag {
  private __kind: 'naturalNumber'
}
type NaturalNumber = number & NaturalNumberTag
declare class PositiveNaturalNumberTag {
  private __kind: 'positiveNaturalNumber'
}
type PositiveNaturalNumber = number & PositiveNaturalNumberTag

/**
 * Check if `value` is a natural number: a real number in the range [0,∞).
 * Particularly useful for dealing with currency.
 *
 * See also `isPositiveNumber`.
 */
export const isNonNegativeNumber = (value: unknown): value is NaturalNumber => {
  if (typeof value !== 'number' || Number.isNaN(value)) return false
  return value >= 0
}

/**
 * Check if `value` is a positive natural number: a real number in the range
 * [1,∞).
 *
 * See also `isNonNegativeNumber`.
 */
export const isPositiveNumber = (
  value: unknown
): value is PositiveNaturalNumber => {
  return isNonNegativeNumber(value) && value > 0
}

/**
 * Coerce `value` to a natural number: a real number in the range [0,∞).
 *
 * Returns `value` if `value` is a natural number (`isNonNegativeNumber`);
 * otherwise returns `0`.
 */
export const asNonNegativeNumber = (value: unknown): number => {
  return isNonNegativeNumber(value) ? value : 0
}
